import React, { useMemo } from "react";
import { observer, inject } from "mobx-react";
import { NavLink, withRouter } from "react-router-dom";
import { generateUrl } from "Services/withDefaultParams";
import Routes from "Configs/routes";
//import { MenuTab, MenuTabItem } from "ComponentsUI/Navigation";
import { MenuTab } from "../componentsUI/Navigation/MenuTab";
import { MenuTabItem } from "../componentsUI/Navigation/MenuTabItem";

import Metrika from "Services/Metrika";
import {
	CLICK_PROVIDER_MENU_TARIFFS,
	CLICK_PROVIDER_MENU_ACTIONS,
	CLICK_PROVIDER_MENU_NEWS,
	CLICK_PROVIDER_MENU_REVIEWS,
	CLICK_PROVIDER_MENU_SERVICES,
} from "Constants/metriks/Yandex";
import {
	PROVIDER_TAB_ACTIONS,
	PROVIDER_TAB_CARD,
	PROVIDER_TAB_REVIEWS,
	PROVIDER_TAB_TARIFFS,
} from "stores/ProviderModel";

const onClickNotHrefMenuItem = (e, cb) => {
	if (e.button === 0) {
		cb();
		e.preventDefault();
	}
};

const onClickMenuItemHandler = (goal) => {};

const _SubMenuContainer = (props) => {
	const providerModel = props.ApplicationModel.providerModel;

	// Ссылка на "О провайдере"
	const providerCardUrl = generateUrl(Routes.ProviderDetails.route, {
		regionUrl: props.match.params.regionUrl,
		providerName: props.match.params.providerName,
	});

	// Ссылка на "Тарифы"
	const providerRatesUrl = generateUrl(Routes.ProviderRates.route, {
		regionUrl: props.match.params.regionUrl,
		providerName: props.match.params.providerName,
	});

	// Ссылка на "Отзыв"
	const providerRatingUrl = generateUrl(Routes.ProvidersReviewListOld.route, {
		regionUrl: props.match.params.regionUrl,
		providerName: props.match.params.providerName,
	});

	// Ссылка на "Акции"
	const providerActionsUrl = generateUrl(Routes.ProvidersActionsList.route, {
		regionUrl: props.match.params.regionUrl,
		providerName: props.match.params.providerName,
	});

	// let providerServicesUrl = generateUrl(
	//     Routes.ProvidersServicesList.route,
	//     {
	//         regionUrl: props.match.params.regionUrl,
	//         providerName: props.match.params.providerName
	//     }
	// );

	// let providerServicesTariff = generateUrl(
	//     Routes.ProvidersTarifficationList.route,
	//     {
	//         regionUrl: props.match.params.regionUrl,
	//         providerName: props.match.params.providerName
	//     }
	// );

	// let providerDistrictsTariff = generateUrl(
	//     Routes.ProviderAddressDistricts.route,
	//     {
	//         regionUrl: props.match.params.regionUrl,
	//         providerName: props.match.params.providerName
	//     }
	// );

	const text = props.ApplicationModel.text;
	const actionTariffs = props?.provider?.info?.cnt_action_tariffs || 0;

	// TODO: rework logic

	// Кнопка "О провайдере"
	const aboutProvider = useMemo(() => {
		return {
			name: text.ABOUT_PROVIDER_MENU,
			url: {
				pathname: providerCardUrl,
				search: props.location.search,
			},
			key: PROVIDER_TAB_CARD,
			cbLink: () => {
				providerModel.changeTab(PROVIDER_TAB_CARD);
			},
		};
	}, [text, providerCardUrl, providerModel, props.location]);

	// кнопка "Тарифы"
	const tariffs = useMemo(() => {
		return props.provider?.info?.cnt_tariffs
			? {
					name: text.menuRates,
					url: providerRatesUrl,
					key: PROVIDER_TAB_TARIFFS,
					goal: CLICK_PROVIDER_MENU_TARIFFS,
					datatest: "providers_provider_tariff",
					cbLink: () => {
						providerModel.changeTab(PROVIDER_TAB_TARIFFS);
						return false;
					},
					counter: props.tariffs,
				}
			: null;
	}, [text.menuRates, providerRatesUrl, props.tariffs, providerModel]);

	const windowSizes = props.ApplicationModel.windowSizeModel.windowSizes;

	// Кнопка "Отзыв"
	const review = useMemo(() => {
		return props.provider?.info?.cnt_reviews
			? {
					name: text.REVIEWS,
					url: providerRatingUrl,
					key: PROVIDER_TAB_REVIEWS,
					onlyLg: true,
					goal: CLICK_PROVIDER_MENU_REVIEWS,
					datatest: "providers_provider_reviews_button",
					cbLink: () => {
						providerModel.changeTab(PROVIDER_TAB_REVIEWS);
					},
				}
			: null;
	}, [props.provider?.info?.cnt_reviews, text.REVIEWS, providerRatingUrl, providerModel]);

	// Кнопка "Акции"
	const actions = useMemo(() => {
		return actionTariffs
			? {
					name: text.menuActions,
					url: providerActionsUrl,
					key: PROVIDER_TAB_ACTIONS,
					goal: CLICK_PROVIDER_MENU_ACTIONS,
					cbLink: () => {
						providerModel.changeTab(PROVIDER_TAB_ACTIONS);
					},
				}
			: null;
	}, [props.actions, actionTariffs, text, providerActionsUrl, providerModel]);

	const menuItems = useMemo(
		() => [aboutProvider, tariffs, review, actions].filter(Boolean),
		[aboutProvider, tariffs, review, actions]
	);

	// Вывод всех созданных кнопок
	const items = useMemo(
		() =>
			menuItems.map((item, index) => {
				return (
					<MenuTabItem
						isProviderMenu={true}
						isActive={providerModel.visibleTab == item.key}
						key={index}
						counter={item.counter}
						onlyLg={item.onlyLg}
						providerTheme={true}
						purpleColor={true}
						clickMenuItem={onClickMenuItemHandler(item.goal)}
					>
						{!item.cb && item.url ? (
							<NavLink
								onClick={() => {
									providerModel.changeTab(item.key);
								}}
								to={item.url}
								datatest={item.datatest}
								exact={index == (0 || 1) ? true : false}
							>
								{item.name}
							</NavLink>
						) : (
							<span onMouseDown={(e) => onClickNotHrefMenuItem(e, item.cb)}>{item.name}</span>
						)}
					</MenuTabItem>
				);
			}),
		[menuItems, providerModel, providerModel.visibleTab]
	);

	// Одна и та же страница или нет
	const isOneTab = menuItems.some((element) => {
		return element.key === "provider_tab_actions" || element.key === "provider_tab_tariffs";
	});

	return <MenuTab providerTheme={true} items={items} isOneTab={!isOneTab} />;
};

export default withRouter(inject("ApplicationModel")(observer(_SubMenuContainer)));
